// extracted by mini-css-extract-plugin
export default {"card-image":"Card_card-image__WEzwB","card-image__preview":"Card_card-image__preview__qnqPO"};